import EBarResourceBody from './components/EBarResourceBody';
import EBarResourceHeading from './components/EBarResourceHeading';

export {
  EBarResourceBody,
  EBarResourceHeading,
};
